import * as TK from 'components/common/Logo/translations/constants';
import { Translations } from 'translations/types';

export const logoEnUsLocale: Translations = {
  [TK.LOGO_ALT]: 'logo',
};
